import { createQueryData } from '../helpers/createQueryData';

const {
  useQuery: useTimeIntervalsQuery,
  createKey: createTimeIntervalsQueryKey,
  fn: fetchTimeIntervals,
} = createQueryData({
  endPoint: 'Acceptance/all_time_intervals',
});

export {
  useTimeIntervalsQuery,
  createTimeIntervalsQueryKey,
  fetchTimeIntervals,
};
